import styled from "styled-components";

export const DescriptionStyle = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-bottom: 16px;
  text-align: center;
  h1 {
    margin-top: 16px;
    font-size: 20px;
    font-weight: 600;
  }
  h2 {
    font-size: 18px;
    font-weight: 400;
  }
`;
